import React from 'react'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious
} from '@/modules/components/ui/carousel'
import { getProgramData } from '~shared/api/single-program-data/single-program-data'
import { ProgramArchiveCard } from '~pages/program-page/components/program-archive-card'

export const ProgramsArchiveSection = ({
  program
}: {
  program: Awaited<ReturnType<typeof getProgramData>>
}) => {
  return (
    <section className='2lg:max-w-[1248px] md:max-w-[832px] mx-auto px-[16px] box-border mt-section-indent'>
      <h2 className='typo-section-heading text-center mb-[50px]'>
        Вам могут подойти
      </h2>
      {program?.linkedPrograms && (
        <Carousel
          className='max-w-[1980px] mx-auto'
          aria-label='Popular programs'
          opts={{ align: 'start', startIndex: 0 }}>
          <CarouselContent className='ml-0 gap-[32px]'>
            {program?.linkedPrograms.map(el => (
              <CarouselItem
                key={el.slug}
                className='2lg:max-w-[380px] md:max-w-[384px] select-none pl-0'>
                <ProgramArchiveCard program={el} />
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className='flex gap-[16px] mx-auto w-fit mt-[30px] md:mt-[40px] xl:mt-[60px]'>
            <CarouselPrevious size='lg' />
            <CarouselNext size='lg' />
          </div>
        </Carousel>
      )}
    </section>
  )
}
